/* eslint-disable func-names */
import Reflux from "reflux";
import {
  getEffectiveMechanism,
  getAllMechanism,
  getResourceList,
  getCurrentMechanismData,
  getAccountResources,
  getMechanismIncludeChildrenPro,
  getAdmRoleRes
} from "api/settingsApi";
import {
  getDictionaryForShopList,
  getDictionaryForUnitList
} from "api/productApi";

const SystemActions = Reflux.createActions({
  getDictionaryForShopList: {
    asyncResult: true
  },
  getDictionaryForUnitList: {
    asyncResult: true
  },
  getMechanismIncludeChildrenPro: {
    // 1.2.7后台返回处理后的数据，不需要前端再度处理数据
    asyncResult: true
  },
  getAllMechanism: {
    asyncResult: true
  },
  getEffectiveMechanism: {
    asyncResult: true
  },
  getAccountResources: {
    asyncResult: true
  },
  getCurrentMechanismData: {
    asyncResult: true
  },
  getStaticAllMenuDataList: {
    asyncResult: true
  },
  getAdmRoleList: {
    asyncResult: true
  },
  getSign: { sync: true },
  setAccountResources: {},
  updateAllAuthArray: {},
  updateNavTab: {}, // 更新导航标签action
  getNavTabMap: {}, //
  deleteNavTab: {}, //
  updateAuthLoading: {},
  clearAllMechanism: {},
  clearCurrentMechanism: {},
  clearRoleMenuStore: {},
  switchOpenKey: {},
  switchShrink: {}, // 收缩侧边栏，
  updateSystemInfo: {} // 更新系统信息
});
SystemActions.getDictionaryForShopList.listen(function(params) {
  const that = this;
  getDictionaryForShopList(params)
    .then(res => that.completed(res))
    .catch(that.failed);
});
SystemActions.getDictionaryForUnitList.listen(function(params) {
  getDictionaryForUnitList(params)
    .then(res => this.completed(res))
    .catch(this.failed);
});
// 1.2.7整理出来的 ------获取解构
SystemActions.getMechanismIncludeChildrenPro.preEmit = function() {
  // SystemActions.updateAuthLoading();
};
SystemActions.getMechanismIncludeChildrenPro.listen(function(
  params,
  type,
  extra
) {
  console.log(params, "获取全部机构");
  getMechanismIncludeChildrenPro({
    mechanismId: 1,
    status: 1,
    extStatus: 1
  })
    .then(res => this.completed(res, type, extra))
    .catch(this.failed);
});
// 获取机构列表
SystemActions.getAllMechanism.preEmit = () => {
  SystemActions.updateAuthLoading();
};

SystemActions.getAllMechanism.listen(function(params, type, extra) {
  console.log(params, "获取全部机构");
  getAllMechanism(params)
    .then(res => this.completed(res, type, extra))
    .catch(this.failed);
});
// 获取新增机构列表
SystemActions.getEffectiveMechanism.preEmit = function() {
  SystemActions.updateAuthLoading();
};
SystemActions.getEffectiveMechanism.listen(function(params, type, extra) {
  console.log(params, "获取全部机构");
  getEffectiveMechanism(params)
    .then(res => this.completed(res, type, extra))
    .catch(this.failed);
});
// 获取账号权限
SystemActions.getAccountResources.listen(function(cb) {
  const that = this;
  getAccountResources()
    .then(res => {
      cb && cb(res);
      return that.completed(res);
    })
    .catch(res => {
      // todo 特殊处理
      if (res.isCancel) {
        cb && cb();
      }
      return that.failed(res);
    });
});
// 获取系统信息
SystemActions.getCurrentMechanismData.listen(function(params) {
  getCurrentMechanismData(params)
    .then(this.completed)
    .catch(this.failed);
});
// 获取所有权限
SystemActions.getStaticAllMenuDataList.listen(function(params) {
  getResourceList(params)
    .then(res => this.completed(res, !params))
    .catch(this.failed);
});
// 获取所选机构的系统管理员权限
SystemActions.getAdmRoleList.listen(function(params) {
  getAdmRoleRes(params)
    .then(res => this.completed(res, !params))
    .catch(this.failed);
});
export default SystemActions;
